import { render } from "./StartingDashboard.vue?vue&type=template&id=1a1156aa&scoped=true"
import script from "./StartingDashboard.vue?vue&type=script&lang=js"
export * from "./StartingDashboard.vue?vue&type=script&lang=js"

import "./StartingDashboard.vue?vue&type=style&index=0&id=1a1156aa&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1156aa"]])

export default __exports__